module.exports = __webpack_public_path__ + "static/Oliver-933beb9ab9261a0ccffdae0c2aec323d.png";